import { RepairFormulaCreatableInterface } from '../interfaces/repair-formula-creatable.interface';
import { RepairFormulaDto } from './repair-formula.dto';
import { PickType } from '@nestjs/swagger';

export class RepairFormulaCreateDto
  extends PickType(RepairFormulaDto, [
    'repairId',
    'repairBumperPaymentType',
    'repairResourceType',
    'repairPaymentType',
    'active',
  ])
  implements RepairFormulaCreatableInterface {}
